export const API_URL = process.env.REACT_APP_API_URL || "";
export const BASE_URL = process.env.REACT_APP_BASE_URL || "";

const shouldUseQueryMode = process.env.REACT_APP_API_QUERY_MODE === "true";

const stripLeadingSlashes = (value = "") => value.replace(/^\/+/, "");
const stripTrailingSlashes = (value = "") => value.replace(/\/+$/, "");

const sanitizeBaseUrl = (url = "") => {
  if (!url) return "";
  const [base] = url.split("?url=");
  return stripTrailingSlashes(base);
};

const joinUrl = (base = "", segment = "") => {
  if (!base) return `/${stripLeadingSlashes(segment)}`;
  if (!segment) return stripTrailingSlashes(base);
  return `${stripTrailingSlashes(base)}/${stripLeadingSlashes(segment)}`;
};

const normalizedApiBase = sanitizeBaseUrl(API_URL);
const normalizedAssetBase = stripTrailingSlashes(BASE_URL) || normalizedApiBase;

export const getApiUrl = (endpoint) => {
  if (!endpoint) return "";

  if (endpoint.startsWith("http")) return endpoint;

  if (endpoint.includes("/uploads/") || endpoint.includes("/images/")) {
    return joinUrl(normalizedAssetBase, endpoint);
  }

 if (shouldUseQueryMode && API_URL.includes("?url=")) {
  return `${API_URL}${endpoint.replace(/^\//, "")}`;
}

  return joinUrl(normalizedApiBase, endpoint);
};
